<div class="slider-question" [class.with-text]="question.options.allowTextInput">
  <div class="slider-question__label">
    <ion-label>{{ question.label }}</ion-label>
    <ion-label class="slider-question__tip">{{ question.tip }}</ion-label>
  </div>

  <div class="input-group" class="slider-question__div" [class.limits-equal]="options.floor === options.ceil">
    <ngx-slider
      class="slider-question__custom"
      (valueChange)="sliderEvent($event)"
      [(value)]="value"
      (mouseup)="save()"
      [options]="options">
    </ngx-slider>
  </div>

  <div class="form-group" *ngIf="question.options.allowTextInput">
    <div class="slider-question__amount">
      <label>{{ question.options.textInputLabel ?? "Type Amount" }}</label>

      <span class="pound" *ngIf="textValue"> &pound;</span>

      <input
        type="tel"
        placeholder="Amount here"
        [maskito]="mask"
        [name]="'textValue' + question.id"
        [(ngModel)]="textValue"
        (modelChange)="updateSlider($event)"
        (blur)="apply()"
        (keyup.enter)="save()"
        (cdkAutofill)="save()" />
    </div>
  </div>
</div>
